// These are the constants for the common styles of the components
export const focusVisibleRing = 'focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none';
export const focusVisibleRingError = 'aria-invalid:ring-destructive/20';
